'use client';

import { useEffect } from 'react';

import {
  clearChunkErrorReloadBudget,
  isChunkLoadError,
  reloadForChunkError,
} from '@cntxt/shared/utilities/errors';

// Evidence the reload budget's past failures are stale, not ongoing.
const HEALTHY_MOUNT_MS = 10_000;

function tryReloadForChunkError(reason: unknown): boolean {
  return isChunkLoadError(reason) && reloadForChunkError();
}

export function ChunkErrorReloader() {
  useEffect(() => {
    const onUnhandledRejection = (event: PromiseRejectionEvent): void => {
      if (tryReloadForChunkError(event.reason)) {
        event.preventDefault();
      }
    };

    const onError = (event: ErrorEvent): void => {
      const candidate = event.error ?? event.message;
      if (tryReloadForChunkError(candidate)) {
        event.preventDefault();
      }
    };

    globalThis.addEventListener('unhandledrejection', onUnhandledRejection);
    globalThis.addEventListener('error', onError);

    const healthyMountTimer = globalThis.setTimeout(
      clearChunkErrorReloadBudget,
      HEALTHY_MOUNT_MS,
    );

    return () => {
      globalThis.removeEventListener(
        'unhandledrejection',
        onUnhandledRejection,
      );
      globalThis.removeEventListener('error', onError);
      globalThis.clearTimeout(healthyMountTimer);
    };
  }, []);

  return null;
}
